import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import MenuIcon from 'images/icons/menu-icon.svg'

const MenuButton = ({ isMenuOpen, onMenuToggle, buttonRef, isSliderOn }) => {
  return (
    <button
      type="button"
      className={cx('menu__button', {
        'is-active': isMenuOpen,
        'is-digitalSlider--active': isSliderOn,
      })}
      onClick={onMenuToggle}
    >
      <div className="menu__button-text">{isMenuOpen ? 'Close' : 'Menu'}</div>
      <div className="menu__button-wrapper" ref={buttonRef}>
        <MenuIcon />
      </div>
    </button>
  )
}

MenuButton.propTypes = {
  onMenuToggle: PropTypes.func,
  isMenuOpen: PropTypes.bool,
  buttonRef: PropTypes.object,
  isSliderOn: PropTypes.bool,
}

export default MenuButton
